import { render, staticRenderFns } from "./KusUserForm.vue?vue&type=template&id=074de978"
import script from "./KusUserForm.vue?vue&type=script&lang=js"
export * from "./KusUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports